module.exports = __webpack_public_path__ + "static/media/de-kleine-aapjes.2bbd19a7.mp4";